import React, { useEffect } from 'react';
import { Grid, Avatar, Typography, makeStyles, Divider, CircularProgress } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Person } from '@material-ui/icons';
import { Skeleton } from '@material-ui/lab';
import store from '../../../redux/store';
import AllEventDetails from './details';
import { userQueryMyEvents, userQueryGetUsersByType } from '../../../hooks';
import { getUserFromEmail, getUserType } from '../../../helpers/event-tour';
import { EVENT_TOUR_PRICING, EVENT_TOUR_MARKET } from '../../../helpers/constants';
import CustomDropdown from '../../Common/Dropdown';

const AllMyEvents = props => {
  const useStyles = makeStyles({
    eventTour: {
      display: 'flex',
      padding: '10px',
      justifyContent: 'center',
      alignItems: 'center',
    },
    eventTourClose: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '10px',
    },
    divider: {
      paddingTop: '0px !important',
    },
    normalLabel: {
      color: '#494949',
    },
    selectedLabel: {
      color: '#5E176A',
      fontWeight: '600',
    },
    normalContainer: {
      margin: '0px 5px 5px 5px !important',
      '&:hover': {
        backgroundColor: '#E9E9E98C',
      },
      paddingTop: '5px',
      borderRadius: '5px',
    },
    selectedContainer: {
      margin: '0px 5px 5px 5px !important',
      backgroundColor: '#F6EBF8',
      borderRadius: '5px',
    },
    loadingContent: {
      padding: '15px',
    },
  });
  const { eventMeta, userSelected, setUserSelected } = props;
  const classes = useStyles();
  const { user } = store.getState();
  const { data: pricingData, isFetching: isPricingFetching } = userQueryGetUsersByType(EVENT_TOUR_PRICING);
  const { data: marketData, isFetching: isMarketFetching } = userQueryGetUsersByType(EVENT_TOUR_MARKET);
  const currentUser = getUserFromEmail(user.email);
  const { type: userType, user: userSelect } = userSelected;
  const { data, isFetching } = userQueryMyEvents(userSelect, userType);

  const handleUserChange = type => (e, newValue) => {
    e.persist();
    setUserSelected({
      type,
      user: newValue,
    });
  };

  useEffect(() => {
    if (pricingData && pricingData.response) {
      const idx = getUserType(pricingData.response, currentUser);
      if (idx >= 0 && !userSelect) {
        setUserSelected({ type: EVENT_TOUR_PRICING, user: pricingData.response[idx] });
        return;
      }
    }
    if (marketData && marketData.response) {
      const idx = getUserType(marketData.response, currentUser);
      if (idx >= 0 && !userSelect) {
        setUserSelected({ type: EVENT_TOUR_MARKET, user: marketData.response[idx] });
      }
    }
  }, [pricingData, marketData]);

  return (
    <>
      <Grid container className={classes.eventTour} spacing={2}>
        <Grid item xs={12}>
          {isPricingFetching ? (
            <Skeleton width={220} height={65} variant="text" />
          ) : (
            <CustomDropdown
              label="Pricing Analyst"
              name="pricing-analyst"
              id="event-tour-pricing"
              width="100%"
              autoComplete
              items={(pricingData && pricingData.response) || []}
              selectedValue={userType === EVENT_TOUR_PRICING ? userSelect : null}
              onChange={handleUserChange(EVENT_TOUR_PRICING)}
            />
          )}
        </Grid>
        <Grid item xs={12}>
          {isMarketFetching ? (
            <Skeleton width={220} height={65} variant="text" />
          ) : (
            <CustomDropdown
              label="Market Analyst"
              id="event-tour-market"
              name="market-analyst"
              width="100%"
              autoComplete
              selectedValue={userType === EVENT_TOUR_MARKET ? userSelect : null}
              items={(marketData && marketData.response) || []}
              onChange={handleUserChange(EVENT_TOUR_MARKET)}
            />
          )}
        </Grid>

        {userSelect && (
          <>
            <Grid item xs={2}>
              <Avatar aria-label="Calendar" style={{ background: '#9C27B0', width: '30px', height: '30px' }}>
                <Person style={{ color: 'white' }} />
              </Avatar>
            </Grid>
            <Grid item xs={10}>
              <Typography>{`${userSelect}@reps2.com`}</Typography>
            </Grid>
            <Grid item xs={12} className={classes.divider}>
              <Divider
                style={{
                  background: '#9C27B0',
                }}
              />
            </Grid>
          </>
        )}

        {isFetching || isPricingFetching || isMarketFetching ? (
          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress style={{ height: '60px', width: '60px' }} />
          </Grid>
        ) : (
          (data &&
            data.response &&
            Array.isArray(data.response) &&
            data.response.length > 0 &&
            data.response.map(item => (
              <AllEventDetails
                key={item.event_id}
                id={item.event_id}
                item={item}
                selected={eventMeta.event_id === item.event_id}
              />
            ))) || <AllEventDetails noEvents />
        )}
      </Grid>
    </>
  );
};

AllMyEvents.propTypes = {
  eventMeta: PropTypes.object.isRequired,
  userSelected: PropTypes.object.isRequired,
  setUserSelected: PropTypes.func.isRequired,
};

export default AllMyEvents;
